import _ from 'lodash';
import { formatPrice } from '@this/src/util/price/price.util';

interface Args {
  name: string;
  price: number;
  distance: number;
}

class MarketLogCandidate {
  public name: string;

  public price: number;

  public distance: number;

  constructor(args?: Args) {
    this.name = (args && args.name) || '';
    this.price = (args && args.price) || 0;
    this.distance = (args && args.distance) || 0;
  }

  distanceDesc() {
    const d = Math.ceil(this.distance);
    return `${d}m`;
  }

  /**
   * 申請時の価格との差額を計算
   * @param orderedPrice 申請時の価格
   * @returns 差額（候補価格 - 申請時価格）
   */
  priceDiff(orderedPrice: number): number {
    return this.price - orderedPrice;
  }

  /**
   * 申請時の価格との差額の説明文を生成
   * @param orderedPrice 申請時の価格
   * @returns 差額の説明文（+や-の符号付き）
   */
  priceDiffDesc(orderedPrice: number): string {
    const diff = this.priceDiff(orderedPrice);
    const sign = diff > 0 ? '+' : '';
    return `${sign}${formatPrice(diff)}`;
  }

  /**
   * 申請時の価格との差額がプラスかどうか判定
   * @param orderedPrice 申請時の価格
   * @returns プラスの場合true
   */
  isPriceDiffPlus(orderedPrice: number): boolean {
    return this.priceDiff(orderedPrice) > 0;
  }
}

export default MarketLogCandidate;
